import React from "react";
import { Row, Table } from "reactstrap";
import { GetLanguageString, BouncingLoader } from "../helper/Components";
import { CashAccountBalanceCard, AmanatAccountBalanceCard, MetricCard } from "./BalanceCards";

const formatRs = (value) =>
  `Rs ${new Intl.NumberFormat().format(Number(value) || 0)}`;

export const getSelectedShareBalance = (context, sourceAccountType) => {
  if (!context) return 0;
  if (sourceAccountType === "amanat" || sourceAccountType === "amanat_account") {
    return Number(context.amanatBalance) || 0;
  }
  return Number(context.cashInHandBalance) || 0;
};

export const getShareMaxTransferable = (context, sourceAccountType) => {
  const totalInfaq = Number(context?.totalInfaq) || 0;
  return Math.min(totalInfaq, getSelectedShareBalance(context, sourceAccountType));
};

const ShareTransferContextPanel = ({
  context,
  loading,
  minimumLabelKey = "share_minimum_halqa",
}) => {
  const breakdown = context?.infaqBreakdown || [];

  return (
    <div className="mb-4">
      {/* TOP ROW: ACCOUNT BALANCES */}
      <Row className="mb-3">
        <CashAccountBalanceCard
          balance={context?.cashInHandBalance}
          loading={loading}
        />
        <AmanatAccountBalanceCard
          balance={context?.amanatBalance}
          loading={loading}
        />
      </Row>

      {/* SECOND ROW: CONTEXT METRICS (LIGHT MATCHING TONES) */}
      <Row className="mb-3">
        <MetricCard
          labelKey="share_total_infaq"
          badgeText="Infaq Summary"
          value={context?.totalInfaq}
          tone="slate"
          loading={loading}
          icon={
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#39576B" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
            </svg>
          }
        />
        <MetricCard
          labelKey={minimumLabelKey}
          badgeText="Calculated Share"
          value={context?.minimumShare}
          tone="emerald"
          loading={loading}
          icon={
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#237A6E" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21.21 15.89A10 10 0 1 1 8 2.83" />
              <path d="M22 12A10 10 0 0 0 12 2v10z" />
            </svg>
          }
        />
      </Row>

      {/* THIRD ROW: INFAQ BREAKDOWN TABLE */}
      <div
        style={{
          background: "#ffffff",
          border: "1px solid #E2E8F0",
          borderRadius: "14px",
          padding: "16px 20px",
          boxShadow: "0 4px 16px rgba(0, 0, 0, 0.04)",
        }}
      >
        <div style={{ fontSize: "14px", fontWeight: "700", color: "#1E293B", marginBottom: "12px", display: "flex", alignItems: "center", gap: "6px" }}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#64748B" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="8" y1="6" x2="21" y2="6" />
            <line x1="8" y1="12" x2="21" y2="12" />
            <line x1="8" y1="18" x2="21" y2="18" />
            <line x1="3" y1="6" x2="3.01" y2="6" />
            <line x1="3" y1="12" x2="3.01" y2="12" />
            <line x1="3" y1="18" x2="3.01" y2="18" />
          </svg>
          <GetLanguageString props="share_infaq_breakdown" />
        </div>
        <Table size="sm" responsive className="mb-0" style={{ borderCollapse: "separate", borderSpacing: "0" }}>
          <thead>
            <tr style={{ background: "#F8FAFC" }}>
              <th style={{ borderTop: "none", borderBottom: "2px solid #E2E8F0", color: "#64748B", fontWeight: "700", fontSize: "12px", padding: "10px 12px" }}>
                <GetLanguageString props="share_infaq_account" />
              </th>
              <th className="text-end" style={{ borderTop: "none", borderBottom: "2px solid #E2E8F0", color: "#64748B", fontWeight: "700", fontSize: "12px", padding: "10px 12px" }}>
                <GetLanguageString props="funds_add_fund_amount" />
              </th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="2" className="text-center py-3 text-muted">
                  <BouncingLoader />
                </td>
              </tr>
            ) : breakdown.length === 0 ? (
              <tr>
                <td colSpan="2" className="text-center py-3 text-muted" style={{ fontSize: "13px" }}>
                  <GetLanguageString props="share_infaq_breakdown_empty" />
                </td>
              </tr>
            ) : (
              breakdown.map((item, idx) => (
                <tr key={item.accountId || idx} style={{ borderBottom: "1px solid #F1F5F9" }}>
                  <td style={{ padding: "10px 12px", fontSize: "13px", fontWeight: "600", color: "#334155" }}>
                    {item.accountName || `Code ${item.accountId}`}
                  </td>
                  <td className="text-end" style={{ padding: "10px 12px", fontSize: "13px", fontWeight: "700", color: "#0F172A" }}>
                    {formatRs(item.amount)}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default ShareTransferContextPanel;
